import { useOutletContext, useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { Table, Input, FormGroup, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import ConfirmDialog from './../../util/ConfirmDialog.js';
import { translations } from './../../i18/translations.js';

const NewsLetterManagement = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const {lang, showAlert, checkAccess} = useOutletContext();

    const [newsLetters, setNewsLetters] = useState([]);
    const [selectedNewsLetter, setSelectedNewsLetter] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [showOld, setShowOld] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchNewsLetters();
    }, [lang, showOld]);

    const fetchNewsLetters = async () => {
        try {
            const payload = {
                filter: {
                    showInvisible: showOld
                }
            };
            const response = await fetch(`${API_URL}/admin/get_newsletter_list.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                setNewsLetters(data);
            }
        } catch (error) {
            console.error("Error fetching newsletters:", error);
        }
    };

    const toggleConfirmDialog = () => setConfirmOpen(!confirmOpen);

    const editNewsLetter = (id) => {
        navigate("/NewsLetterManagementEdit/" + id);
    };

    const deleteNewsLetter = async () => {
        try {
            const payload = {
                newsletter: {
                    id: selectedNewsLetter.id
                }
            };

            const response = await fetch(`${API_URL}/admin/delete_newsletter.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                showAlert(data.alert);
                fetchNewsLetters();
                toggleConfirmDialog();
            }
        } catch (error) {
            console.error("Error fetching members:", error);
        }
    };

    const handleDeleteNewsLetterClick = async (selectedNewsLetter) => {
        setSelectedNewsLetter(selectedNewsLetter);
        toggleConfirmDialog();
    };

    const handleShowOldSwitch = (e) => {
        const {checked} = e.target;
        setShowOld(checked);
    };

    return (
            <div className="mbkegy-content">
                <h1 className="mbkegy-content">{translations[lang].newsletter_management}</h1>
                <FormGroup switch>
                    <Input id="showOld" type="switch" checked={showOld} onChange={handleShowOldSwitch} />
                    <Label for="showOld" className="text-nowrap">{translations[lang].newsletter_show_invisible}</Label>
                </FormGroup>
            
                <Button outline size="sm" color="primary" onClick={() => editNewsLetter(-1)}><FontAwesomeIcon icon={faPlus} />{translations[lang].newsletter_new}</Button>
            
                <Table striped className="mbkegy-table">
                    <thead>
                        <tr>
                            <th style={{width: '50%'}}>{translations[lang].col_name}</th>
                            <th style={{width: '50%'}}>{translations[lang].col_subject}</th>
                            <th style={{width: '100px'}}>{translations[lang].col_count}</th>
                            <th style={{width: '90px'}}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
            
                        {newsLetters.map((l) => (
                                <tr key={l.id}>
                                    <td>{l.name}</td>
                                    <td>{l.subject}</td>
                                    <td>{l.count}</td>
                                    <td className="text-nowrap">
                                        <Button outline size="sm" color="primary" onClick={() => editNewsLetter(l.id)}><FontAwesomeIcon icon={faPenToSquare} /></Button>
                                        <Button outline size="sm" color="danger" onClick={() => handleDeleteNewsLetterClick(l)}><FontAwesomeIcon icon={faTrashCan} /></Button>                    
                                    </td>
                                </tr>
                                        ))}
                    </tbody>
                </Table>
            
            
            
                <ConfirmDialog 
                    title={translations[lang].newsletter_delete}
                    yes={translations[lang].yes}
                    no={translations[lang].cancel}
                    isOpen={confirmOpen} 
                    toggle={toggleConfirmDialog} 
                    onConfirm={deleteNewsLetter} 
                    message={translations[lang].newsletter_delete_confirm}
                    />
            
            </div>
            );
};

export default NewsLetterManagement;